import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import { AnimatedGrid } from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from 'eco-design-reliance/getLocal';

export default function SectionImageText() {
    const { t } = useLang('SectionImageText');
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)
    return (
        <div className={`page-SectionImageText ${isEu ? 'range3' : ""} ${styles.SectionImageText} GtmModuleData-section`} data-section-id="d3c-SectionImageText" id='SectionImageText'>
            {!isEu && <EcoSpace />}
            <CommonTitle
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
            />
            <EcoSpaceSmall />
            <AnimatedGrid variant="fadeInUp" options={{ stagger: 0.2, delay: 200, threshold: 0.2 }}>
                <div className={`eco-content ${styles.SectionImageText}`}>
                    <EcoImg
                        pc={'https://websiteoss.ecoflow.com/figma-uploads/1757673057903-dkoltj-compressed-Charge%20up%2C%20fast%2C%20and%20everywhere.jpg'}
                        h5={'https://websiteoss.ecoflow.com/figma-uploads/1757758924421-f90rmm-compressed-Charge%20up%2C%20fast%2C%20and%20everywhere.jpg'}
                        isOpenLazy={true}
                    />
                </div>
            </AnimatedGrid>
        </div>
    );
}
